import data from './fxRegister.json';
import { SET_PAGE_SIZE, SET_SEARCH_TERM } from '../enums';

const getData = () => {
  if (window.fxRegisterEntities) {
    return window.fxRegisterEntities;
  }else{
    return data;
  }
}

export const fxData = (state = getData()) => {
  return state;
}

export const pageSize = (state = 25, action) => {
  switch (action.type) {
    case SET_PAGE_SIZE:
      return state += 25;
    default:
      return state;
  }
}

export const searchTerm = (state = '', action) => {
  switch (action.type) {
    case SET_SEARCH_TERM:
      return action.obj;
    default:
      return state;
  }
}